<template>
    <div class="card">
        <div class="chart-card">
            <div class="card-header">实时指数</div>
            <div class="chart-info">
                <div class="info-item">威胁指数：<span>{{ data.index }}</span></div>
                <div class="info-item">平均威胁：<span>{{ data.speed }}</span></div>
                <div class="info-item">消耗时间：<span>{{ data.time }}</span></div>
            </div>
            <div ref="chartRef" class="chart-body"></div>
        </div>

    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import * as echarts from 'echarts'

const chartRef = ref(null)

const data = {
    index: 1.6,
    speed: '23 %',
    time: '12 min',
    series: [0.8, 1.1, 1.3, 2.0, 1.5, 1.7, 2.3, 2.6, 2.1]
}

onMounted(() => {
    const chart = echarts.init(chartRef.value)
    chart.setOption({
        tooltip: { trigger: 'axis' },
        xAxis: {
            type: 'category',
            data: ['00:00', '02:00', '04:00', '06:00', '08:00', '10:00', '12:00', '14:00', '16:00'],
            axisLine: { lineStyle: { color: '#2c70b6' } },
            axisLabel: { color: '#fff' },
        },
        yAxis: {
            type: 'value',
            splitLine: { show: false },
            axisLine: { lineStyle: { color: '#2c70b6' } },
            axisLabel: { color: '#fff' },
        },
        series: [
            {
                data: data.series,
                type: 'line',
                smooth: true,
                itemStyle: {
                    color: '#00f6ff'
                },
                lineStyle: {
                    width: 2
                },
                areaStyle: {
                    color: 'rgba(0,246,255,0.2)'
                }
            }
        ],
        grid: {
            left: '8%',
            right: '5%',
            bottom: '12%',
            top: '20%'
        }
    })
})
</script>

<style scoped>
.chart-card {
    background: rgba(0, 52, 101, 0.7);
    border-radius: 8px;
    padding: 16px;
    color: #ffffff;
}

.card-header {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 12px;
    color: #00ffff;
}

.chart-info {
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    margin-bottom: 10px;
}

.chart-info .info-item span {
    color: #00ffcc;
    margin-left: 4px;
}

.chart-body {
    width: 100%;
    height: 200px;
}
</style>